import React from 'react'
import { css } from 'aphrodite'
import { Container, Row, Col, FormGroup, Input } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import string from '../../utils/strings'

import Sitemap from '../partials/Sitemap'
import ResponseAlert from '../partials/ResponseAlert'

import style from './style'

const sitemapOptions = [
  { url: '/auth', title: 'Auth' },
  { url: '/remind', title: 'Remind' }
]

@inject('Auth')
@observer
export class Remind extends React.Component {
  constructor (props) {
    super(props)

    const _query = string.parseQueryParams(props.location.search || '')
    this.state = {
      code: _query.resetCode,
      editor: {
        ...(_query.resetCode ? { password: '' } : { email: '' })
      }
    }
  }

  onInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        [e.target.name]: e.target.value
      }
    })
  }

  onFormSubmit (e) {
    e.preventDefault()

    if (this.state.code) {
      return this.props.Auth.reset({
        ...this.state.editor,
        code: this.state.code
      })
    }

    this.props.Auth.remind(this.state.editor)
  }

  render () {
    return [
      <Sitemap key={0} sitemap={sitemapOptions} />,
      <section key={1} className={css(style.main.section)}>
        <Container>
          <Row className={`d-flex align-items-center justify-content-center`}>
            <Col
              tag='form'
              xs='12'
              sm='6'
              className={css(style.box.wrapper)}
              onSubmit={this.onFormSubmit.bind(this)}
            >
              <Row tag='header'>
                <Col className={css(style.box.header)}>
                  {!this.state.code
                    ? 'I forgot my password'
                    : 'Reset my password'}
                </Col>
              </Row>
              <Row className={css(style.form.wrapper)}>
                {!this.state.code
                  ? [
                    <Col xs='12' key={0}>
                      {!this.props.Auth.response.remind ? null : (
                        <ResponseAlert
                          statusCode={
                              this.props.Auth.response.remind.statusCode
                            }
                          alert={
                              +this.props.Auth.response.remind.statusCode >= 400
                                ? 'danger'
                                : 'success'
                            }
                          content={
                              this.props.Auth.response.remind.data.message
                            }
                          />
                        )}
                    </Col>,
                    <Col xs='12' key={1}>
                      <FormGroup className={css(style.form.formGroup)}>
                        <Input
                          type={`text`}
                          name={`email`}
                          autoComplete={`email`}
                          placeholder={`Email`}
                          onChange={this.onInputChange.bind(this)}
                          value={this.state.editor.email}
                          className={css(
                              style.form.input,
                              style.form.singleRowInput
                            )}
                          />
                      </FormGroup>
                    </Col>
                  ]
                  : [
                    <Col xs='12' key={0}>
                      {!this.props.Auth.response.reset ? null : (
                        <ResponseAlert
                          statusCode={
                              this.props.Auth.response.reset.statusCode
                            }
                          alert={
                              +this.props.Auth.response.reset.statusCode >= 400
                                ? 'danger'
                                : 'success'
                            }
                          content={
                              this.props.Auth.response.reset.data.message
                            }
                          altContent={
                              +this.props.Auth.response.reset.statusCode < 400
                                ? 'Great! You can log in now.'
                                : null
                            }
                          />
                        )}
                    </Col>,
                    <Col xs='12' key={1}>
                      <FormGroup className={css(style.form.formGroup)}>
                        <Input
                          type={`password`}
                          name={`password`}
                          autoComplete={`password`}
                          placeholder={`Password`}
                          onChange={this.onInputChange.bind(this)}
                          value={this.state.editor.password}
                          className={css(
                              style.form.input,
                              style.form.singleRowInput
                            )}
                          />
                      </FormGroup>
                    </Col>
                  ]}
              </Row>
              <Row tag='footer'>
                <Col
                  className={`d-flex justify-content-end ${css(
                    style.box.footer
                  )}`}
                >
                  <input
                    type={`submit`}
                    value={!this.state.code ? 'Remind' : 'Reset'}
                    className={css(style.form.submit)}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    ]
  }
}

export default Remind



// WEBPACK FOOTER //
// ./src/components/Remind/index.js